"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _albino = _interopRequireDefault(require("./23_group_2023_07_05/albino"));

var _alpignano = _interopRequireDefault(require("./23_group_2023_07_05/alpignano"));

var _altavillaVicentina = _interopRequireDefault(require("./23_group_2023_07_05/altavilla-vicentina"));

var _altoRenoTerme = _interopRequireDefault(require("./23_group_2023_07_05/alto-reno-terme"));

var _arcugnano = _interopRequireDefault(require("./23_group_2023_07_05/arcugnano"));

var _artaTerme = _interopRequireDefault(require("./23_group_2023_07_05/arta-terme"));

var _atessa = _interopRequireDefault(require("./23_group_2023_07_05/atessa"));

var _aviano = _interopRequireDefault(require("./23_group_2023_07_05/aviano"));

var _azzanoDecimo = _interopRequireDefault(require("./23_group_2023_07_05/azzano-decimo"));

var _bacoli = _interopRequireDefault(require("./23_group_2023_07_05/bacoli"));

var _bagniDiLucca = _interopRequireDefault(require("./23_group_2023_07_05/bagni-di-lucca"));

var _baselgaDiPine = _interopRequireDefault(require("./23_group_2023_07_05/baselga-di-pine"));

var _borgia = _interopRequireDefault(require("./23_group_2023_07_05/borgia"));

var _borgosatollo = _interopRequireDefault(require("./23_group_2023_07_05/borgosatollo"));

var _borsoDelGrappa = _interopRequireDefault(require("./23_group_2023_07_05/borso-del-grappa"));

var _bovisioMasciago = _interopRequireDefault(require("./23_group_2023_07_05/bovisio-masciago"));

var _brivio = _interopRequireDefault(require("./23_group_2023_07_05/brivio"));

var _brugnera = _interopRequireDefault(require("./23_group_2023_07_05/brugnera"));

var _budoni = _interopRequireDefault(require("./23_group_2023_07_05/budoni"));

var _bulciago = _interopRequireDefault(require("./23_group_2023_07_05/bulciago"));

var _busetoPalizzolo = _interopRequireDefault(require("./23_group_2023_07_05/buseto-palizzolo"));

var _cadoneghe = _interopRequireDefault(require("./23_group_2023_07_05/cadoneghe"));

var _calatabiano = _interopRequireDefault(require("./23_group_2023_07_05/calatabiano"));

var _calci = _interopRequireDefault(require("./23_group_2023_07_05/calci"));

var _calenzano = _interopRequireDefault(require("./23_group_2023_07_05/calenzano"));

var _calolziocorte = _interopRequireDefault(require("./23_group_2023_07_05/calolziocorte"));

var _caluscoDAdda = _interopRequireDefault(require("./23_group_2023_07_05/calusco-d-adda"));

var _campagna = _interopRequireDefault(require("./23_group_2023_07_05/campagna"));

var _carmignano = _interopRequireDefault(require("./23_group_2023_07_05/carmignano"));

var _carnate = _interopRequireDefault(require("./23_group_2023_07_05/carnate"));

var _carovilli = _interopRequireDefault(require("./23_group_2023_07_05/carovilli"));

var _casalbore = _interopRequireDefault(require("./23_group_2023_07_05/casalbore"));

var _casaliDelManco = _interopRequireDefault(require("./23_group_2023_07_05/casali-del-manco"));

var _casarsaDellaDelizia = _interopRequireDefault(require("./23_group_2023_07_05/casarsa-della-delizia"));

var _cassanoMagnago = _interopRequireDefault(require("./23_group_2023_07_05/cassano-magnago"));

var _castelDiLama = _interopRequireDefault(require("./23_group_2023_07_05/castel-di-lama"));

var _casteldaccia = _interopRequireDefault(require("./23_group_2023_07_05/casteldaccia"));

var _castellalto = _interopRequireDefault(require("./23_group_2023_07_05/castellalto"));

var _castelliCalepio = _interopRequireDefault(require("./23_group_2023_07_05/castelli-calepio"));

var _caulonia = _interopRequireDefault(require("./23_group_2023_07_05/caulonia"));

var _ceranesi = _interopRequireDefault(require("./23_group_2023_07_05/ceranesi"));

var _cermenate = _interopRequireDefault(require("./23_group_2023_07_05/cermenate"));

var _chiaramonteGulfi = _interopRequireDefault(require("./23_group_2023_07_05/chiaramonte-gulfi"));

var _cittaDiCastello = _interopRequireDefault(require("./23_group_2023_07_05/citta-di-castello"));

var _claut = _interopRequireDefault(require("./23_group_2023_07_05/claut"));

var _codroipo = _interopRequireDefault(require("./23_group_2023_07_05/codroipo"));

var _colico = _interopRequireDefault(require("./23_group_2023_07_05/colico"));

var _conselve = _interopRequireDefault(require("./23_group_2023_07_05/conselve"));

var _cordovado = _interopRequireDefault(require("./23_group_2023_07_05/cordovado"));

var _curinga = _interopRequireDefault(require("./23_group_2023_07_05/curinga"));

var _darfoBoarioTerme = _interopRequireDefault(require("./23_group_2023_07_05/darfo-boario-terme"));

var _dresano = _interopRequireDefault(require("./23_group_2023_07_05/dresano"));

var _erba = _interopRequireDefault(require("./23_group_2023_07_05/erba"));

var _fierozzo = _interopRequireDefault(require("./23_group_2023_07_05/fierozzo"));

var _fiesole = _interopRequireDefault(require("./23_group_2023_07_05/fiesole"));

var _fisciano = _interopRequireDefault(require("./23_group_2023_07_05/fisciano"));

var _folgaria = _interopRequireDefault(require("./23_group_2023_07_05/folgaria"));

var _frascati = _interopRequireDefault(require("./23_group_2023_07_05/frascati"));

var _gargnano = _interopRequireDefault(require("./23_group_2023_07_05/gargnano"));

var _gazzoVeronese = _interopRequireDefault(require("./23_group_2023_07_05/gazzo-veronese"));

var _giardiniNaxos = _interopRequireDefault(require("./23_group_2023_07_05/giardini-naxos"));

var _isolaDiCapoRizzuto = _interopRequireDefault(require("./23_group_2023_07_05/isola-di-capo-rizzuto"));

var _lagundo = _interopRequireDefault(require("./23_group_2023_07_05/lagundo"));

var _lainate = _interopRequireDefault(require("./23_group_2023_07_05/lainate"));

var _legnago = _interopRequireDefault(require("./23_group_2023_07_05/legnago"));

var _lumezzane = _interopRequireDefault(require("./23_group_2023_07_05/lumezzane"));

var _magione = _interopRequireDefault(require("./23_group_2023_07_05/magione"));

var _mandelloDelLario = _interopRequireDefault(require("./23_group_2023_07_05/mandello-del-lario"));

var _manerbaDelGarda = _interopRequireDefault(require("./23_group_2023_07_05/manerba-del-garda"));

var _maniago = _interopRequireDefault(require("./23_group_2023_07_05/maniago"));

var _mapello = _interopRequireDefault(require("./23_group_2023_07_05/mapello"));

var _marcianise = _interopRequireDefault(require("./23_group_2023_07_05/marcianise"));

var _marenoDiPiave = _interopRequireDefault(require("./23_group_2023_07_05/mareno-di-piave"));

var _marianoComense = _interopRequireDefault(require("./23_group_2023_07_05/mariano-comense"));

var _martignacco = _interopRequireDefault(require("./23_group_2023_07_05/martignacco"));

var _martinsicuro = _interopRequireDefault(require("./23_group_2023_07_05/martinsicuro"));

var _mascali = _interopRequireDefault(require("./23_group_2023_07_05/mascali"));

var _massa = _interopRequireDefault(require("./23_group_2023_07_05/massa"));

var _merano = _interopRequireDefault(require("./23_group_2023_07_05/merano"));

var _miglianico = _interopRequireDefault(require("./23_group_2023_07_05/miglianico"));

var _minerbe = _interopRequireDefault(require("./23_group_2023_07_05/minerbe"));

var _missaglia = _interopRequireDefault(require("./23_group_2023_07_05/missaglia"));

var _monteCompatri = _interopRequireDefault(require("./23_group_2023_07_05/monte-compatri"));

var _monteSantAngelo = _interopRequireDefault(require("./23_group_2023_07_05/monte-sant-angelo"));

var _montecchioPrecalcino = _interopRequireDefault(require("./23_group_2023_07_05/montecchio-precalcino"));

var _montefalcione = _interopRequireDefault(require("./23_group_2023_07_05/montefalcione"));

var _montepaone = _interopRequireDefault(require("./23_group_2023_07_05/montepaone"));

var _monterealeValcellina = _interopRequireDefault(require("./23_group_2023_07_05/montereale-valcellina"));

var _montopoliInValDArno = _interopRequireDefault(require("./23_group_2023_07_05/montopoli-in-val-d-arno"));

var _negrarDiValpolicella = _interopRequireDefault(require("./23_group_2023_07_05/negrar-di-valpolicella"));

var _noceraInferiore = _interopRequireDefault(require("./23_group_2023_07_05/nocera-inferiore"));

var _noceraTerinese = _interopRequireDefault(require("./23_group_2023_07_05/nocera-terinese"));

var _nogara = _interopRequireDefault(require("./23_group_2023_07_05/nogara"));

var _nola = _interopRequireDefault(require("./23_group_2023_07_05/nola"));

var _nuraminis = _interopRequireDefault(require("./23_group_2023_07_05/nuraminis"));

var _olgiateOlona = _interopRequireDefault(require("./23_group_2023_07_05/olgiate-olona"));

var _ospitaletto = _interopRequireDefault(require("./23_group_2023_07_05/ospitaletto"));

var _ovindoli = _interopRequireDefault(require("./23_group_2023_07_05/ovindoli"));

var _paceco = _interopRequireDefault(require("./23_group_2023_07_05/paceco"));

var _palazzoloDelloStella = _interopRequireDefault(require("./23_group_2023_07_05/palazzolo-dello-stella"));

var _paliano = _interopRequireDefault(require("./23_group_2023_07_05/paliano"));

var _paola = _interopRequireDefault(require("./23_group_2023_07_05/paola"));

var _passirano = _interopRequireDefault(require("./23_group_2023_07_05/passirano"));

var _pietracamela = _interopRequireDefault(require("./23_group_2023_07_05/pietracamela"));

var _pieveANievole = _interopRequireDefault(require("./23_group_2023_07_05/pieve-a-nievole"));

var _pieveDiCadore = _interopRequireDefault(require("./23_group_2023_07_05/pieve-di-cadore"));

var _pioveDiSacco = _interopRequireDefault(require("./23_group_2023_07_05/piove-di-sacco"));

var _piraino = _interopRequireDefault(require("./23_group_2023_07_05/piraino"));

var _povoletto = _interopRequireDefault(require("./23_group_2023_07_05/povoletto"));

var _puegnagoDelGarda = _interopRequireDefault(require("./23_group_2023_07_05/puegnago-del-garda"));

var _reanaDelRojale = _interopRequireDefault(require("./23_group_2023_07_05/reana-del-rojale"));

var _riano = _interopRequireDefault(require("./23_group_2023_07_05/riano"));

var _rivaDelGarda = _interopRequireDefault(require("./23_group_2023_07_05/riva-del-garda"));

var _rivanazzanoTerme = _interopRequireDefault(require("./23_group_2023_07_05/rivanazzano-terme"));

var _rivergaro = _interopRequireDefault(require("./23_group_2023_07_05/rivergaro"));

var _roccaPriora = _interopRequireDefault(require("./23_group_2023_07_05/rocca-priora"));

var _rodengoSaiano = _interopRequireDefault(require("./23_group_2023_07_05/rodengo-saiano"));

var _rogeno = _interopRequireDefault(require("./23_group_2023_07_05/rogeno"));

var _sacile = _interopRequireDefault(require("./23_group_2023_07_05/sacile"));

var _sanBonifacio = _interopRequireDefault(require("./23_group_2023_07_05/san-bonifacio"));

var _sanDemetrioCorone = _interopRequireDefault(require("./23_group_2023_07_05/san-demetrio-corone"));

var _sanGiovanniLaPunta = _interopRequireDefault(require("./23_group_2023_07_05/san-giovanni-la-punta"));

var _sanGiovanniLupatoto = _interopRequireDefault(require("./23_group_2023_07_05/san-giovanni-lupatoto"));

var _sanLorenzoDelVallo = _interopRequireDefault(require("./23_group_2023_07_05/san-lorenzo-del-vallo"));

var _sanMicheleAllAdige = _interopRequireDefault(require("./23_group_2023_07_05/san-michele-all-adige"));

var _sanVitoAlTagliamento = _interopRequireDefault(require("./23_group_2023_07_05/san-vito-al-tagliamento"));

var _santAmbrogioDiValpolicella = _interopRequireDefault(require("./23_group_2023_07_05/sant-ambrogio-di-valpolicella"));

var _santaMariaCapuaVetere = _interopRequireDefault(require("./23_group_2023_07_05/santa-maria-capua-vetere"));

var _santaMariaLaFossa = _interopRequireDefault(require("./23_group_2023_07_05/santa-maria-la-fossa"));

var _sarezzo = _interopRequireDefault(require("./23_group_2023_07_05/sarezzo"));

var _sarnico = _interopRequireDefault(require("./23_group_2023_07_05/sarnico"));

var _savignanoSulRubicone = _interopRequireDefault(require("./23_group_2023_07_05/savignano-sul-rubicone"));

var _scafa = _interopRequireDefault(require("./23_group_2023_07_05/scafa"));

var _scandale = _interopRequireDefault(require("./23_group_2023_07_05/scandale"));

var _selvaDeiMolini = _interopRequireDefault(require("./23_group_2023_07_05/selva-dei-molini"));

var _seravezza = _interopRequireDefault(require("./23_group_2023_07_05/seravezza"));

var _serenDelGrappa = _interopRequireDefault(require("./23_group_2023_07_05/seren-del-grappa"));

var _seriate = _interopRequireDefault(require("./23_group_2023_07_05/seriate"));

var _sersale = _interopRequireDefault(require("./23_group_2023_07_05/sersale"));

var _soglianoAlRubicone = _interopRequireDefault(require("./23_group_2023_07_05/sogliano-al-rubicone"));

var _sora = _interopRequireDefault(require("./23_group_2023_07_05/sora"));

var _sorisole = _interopRequireDefault(require("./23_group_2023_07_05/sorisole"));

var _spoleto = _interopRequireDefault(require("./23_group_2023_07_05/spoleto"));

var _staranzano = _interopRequireDefault(require("./23_group_2023_07_05/staranzano"));

var _tarcento = _interopRequireDefault(require("./23_group_2023_07_05/tarcento"));

var _tavernerio = _interopRequireDefault(require("./23_group_2023_07_05/tavernerio"));

var _teano = _interopRequireDefault(require("./23_group_2023_07_05/teano"));

var _tito = _interopRequireDefault(require("./23_group_2023_07_05/tito"));

var _tortoreto = _interopRequireDefault(require("./23_group_2023_07_05/tortoreto"));

var _tossicia = _interopRequireDefault(require("./23_group_2023_07_05/tossicia"));

var _trevi = _interopRequireDefault(require("./23_group_2023_07_05/trevi"));

var _triuggio = _interopRequireDefault(require("./23_group_2023_07_05/triuggio"));

var _valfornace = _interopRequireDefault(require("./23_group_2023_07_05/valfornace"));

var _valleCastellana = _interopRequireDefault(require("./23_group_2023_07_05/valle-castellana"));

var _villaSantaLucia = _interopRequireDefault(require("./23_group_2023_07_05/villa-santa-lucia"));

var _villafrancaInLunigiana = _interopRequireDefault(require("./23_group_2023_07_05/villafranca-in-lunigiana"));

var _zafferanaEtnea = _interopRequireDefault(require("./23_group_2023_07_05/zafferana-etnea"));

var _zoppola = _interopRequireDefault(require("./23_group_2023_07_05/zoppola"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = _objectSpread({}, _albino["default"], {}, _alpignano["default"], {}, _altavillaVicentina["default"], {}, _altoRenoTerme["default"], {}, _arcugnano["default"], {}, _artaTerme["default"], {}, _atessa["default"], {}, _aviano["default"], {}, _azzanoDecimo["default"], {}, _bacoli["default"], {}, _bagniDiLucca["default"], {}, _baselgaDiPine["default"], {}, _borgia["default"], {}, _borgosatollo["default"], {}, _borsoDelGrappa["default"], {}, _bovisioMasciago["default"], {}, _brivio["default"], {}, _brugnera["default"], {}, _budoni["default"], {}, _bulciago["default"], {}, _busetoPalizzolo["default"], {}, _cadoneghe["default"], {}, _calatabiano["default"], {}, _calci["default"], {}, _calenzano["default"], {}, _calolziocorte["default"], {}, _caluscoDAdda["default"], {}, _campagna["default"], {}, _carmignano["default"], {}, _carnate["default"], {}, _carovilli["default"], {}, _casalbore["default"], {}, _casaliDelManco["default"], {}, _casarsaDellaDelizia["default"], {}, _cassanoMagnago["default"], {}, _castelDiLama["default"], {}, _casteldaccia["default"], {}, _castellalto["default"], {}, _castelliCalepio["default"], {}, _caulonia["default"], {}, _ceranesi["default"], {}, _cermenate["default"], {}, _chiaramonteGulfi["default"], {}, _cittaDiCastello["default"], {}, _claut["default"], {}, _codroipo["default"], {}, _colico["default"], {}, _conselve["default"], {}, _cordovado["default"], {}, _curinga["default"], {}, _darfoBoarioTerme["default"], {}, _dresano["default"], {}, _erba["default"], {}, _fierozzo["default"], {}, _fiesole["default"], {}, _fisciano["default"], {}, _folgaria["default"], {}, _frascati["default"], {}, _gargnano["default"], {}, _gazzoVeronese["default"], {}, _giardiniNaxos["default"], {}, _isolaDiCapoRizzuto["default"], {}, _lagundo["default"], {}, _lainate["default"], {}, _legnago["default"], {}, _lumezzane["default"], {}, _magione["default"], {}, _mandelloDelLario["default"], {}, _manerbaDelGarda["default"], {}, _maniago["default"], {}, _mapello["default"], {}, _marcianise["default"], {}, _marenoDiPiave["default"], {}, _marianoComense["default"], {}, _martignacco["default"], {}, _martinsicuro["default"], {}, _mascali["default"], {}, _massa["default"], {}, _merano["default"], {}, _miglianico["default"], {}, _minerbe["default"], {}, _missaglia["default"], {}, _monteCompatri["default"], {}, _monteSantAngelo["default"], {}, _montecchioPrecalcino["default"], {}, _montefalcione["default"], {}, _montepaone["default"], {}, _monterealeValcellina["default"], {}, _montopoliInValDArno["default"], {}, _negrarDiValpolicella["default"], {}, _noceraInferiore["default"], {}, _noceraTerinese["default"], {}, _nogara["default"], {}, _nola["default"], {}, _nuraminis["default"], {}, _olgiateOlona["default"], {}, _ospitaletto["default"], {}, _ovindoli["default"], {}, _paceco["default"], {}, _palazzoloDelloStella["default"], {}, _paliano["default"], {}, _paola["default"], {}, _passirano["default"], {}, _pietracamela["default"], {}, _pieveANievole["default"], {}, _pieveDiCadore["default"], {}, _pioveDiSacco["default"], {}, _piraino["default"], {}, _povoletto["default"], {}, _puegnagoDelGarda["default"], {}, _reanaDelRojale["default"], {}, _riano["default"], {}, _rivaDelGarda["default"], {}, _rivanazzanoTerme["default"], {}, _rivergaro["default"], {}, _roccaPriora["default"], {}, _rodengoSaiano["default"], {}, _rogeno["default"], {}, _sacile["default"], {}, _sanBonifacio["default"], {}, _sanDemetrioCorone["default"], {}, _sanGiovanniLaPunta["default"], {}, _sanGiovanniLupatoto["default"], {}, _sanLorenzoDelVallo["default"], {}, _sanMicheleAllAdige["default"], {}, _sanVitoAlTagliamento["default"], {}, _santAmbrogioDiValpolicella["default"], {}, _santaMariaCapuaVetere["default"], {}, _santaMariaLaFossa["default"], {}, _sarezzo["default"], {}, _sarnico["default"], {}, _savignanoSulRubicone["default"], {}, _scafa["default"], {}, _scandale["default"], {}, _selvaDeiMolini["default"], {}, _seravezza["default"], {}, _serenDelGrappa["default"], {}, _seriate["default"], {}, _sersale["default"], {}, _soglianoAlRubicone["default"], {}, _sora["default"], {}, _sorisole["default"], {}, _spoleto["default"], {}, _staranzano["default"], {}, _tarcento["default"], {}, _tavernerio["default"], {}, _teano["default"], {}, _tito["default"], {}, _tortoreto["default"], {}, _tossicia["default"], {}, _trevi["default"], {}, _triuggio["default"], {}, _valfornace["default"], {}, _valleCastellana["default"], {}, _villaSantaLucia["default"], {}, _villafrancaInLunigiana["default"], {}, _zafferanaEtnea["default"], {}, _zoppola["default"]);

exports["default"] = _default;